import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { TextField, Button, Box } from "@mui/material";
import { Field, Form, Formik } from "formik";
import { object, string } from "yup";
import { FaLock } from "react-icons/fa";
import css from "./LoginForm.module.css";
import { fetchUsers } from "../../redux/users/operations";
import { selectUsers } from "../../redux/users/slice";

const initalValues = {
  email: "",
  password: "",
};

const MaterialForm = () => {

    const dispatch = useDispatch();
    const users = useSelector(selectUsers);
    
    useEffect(() => {
        dispatch(fetchUsers());
    }, []);

    const handleLogin = ({ email, password }) => {
        // const { email, password } = values;

        const user = users.find(user => user.email === email && user.password === password);
        if (user) {
            alert(`Welcome ${user.name}`);
        } else {
            alert("Invalid email or password");
        }
    }


  return (
    <div className={css.MaterialForm}>
      <Formik
        initialValues={initalValues}
        validationSchema={object({
          email: string().required("Please enter email").email("Invalid email"),
          password: string()
            .required("Please enter password")
            .min(7, "Password should be minimum 7 characters long"),
        })}
        onSubmit={(values, actions) => {
          handleLogin(values);
          actions.resetForm();
        }}
      >
        {({ errors, isValid, touched, dirty }) => (
            <Form>
            <div style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    color: "#21035a",
                    gap: "10px",
                }}>
                <h2>Login</h2>
                <FaLock size={38}/>
            </div>
            
            <Box height={14} />
            <Field
              name="email"
              type="email"
              as={TextField}
              variant="outlined"
              color="primary"
              label="Email"
              fullWidt
              error={Boolean(errors.email) && Boolean(touched.email)}
              helperText={Boolean(touched.email) && errors.email}
            />
            <Box height={14} />
            <Field
              name="password"
              type="password"
              as={TextField}
              variant="outlined"
              color="primary"
              label="Password"
              fullWidth
              error={Boolean(errors.password) && Boolean(touched.password)}
              helperText={Boolean(touched.password) && errors.password}
            />
            <Box height={44} />

            <Button
              type="submit"
              variant="contained"
              color="primary"
              size="large"
              disabled={!isValid || !dirty}
            >
              Log in
            </Button>
          </Form>
        )}
      </Formik>
    </div>
  );
};

export default MaterialForm;